import React from 'react';
import { Home, Monitor } from 'lucide-react';

type TuitionTypeOption = 'physical' | 'online' | 'both';

interface TuitionTypeOptionContentProps {
  type: TuitionTypeOption;
  label: string;
  showSelectedIndicator?: boolean;
  selectedLabel?: string;
}

const iconClassName = 'h-8 w-8';

const TuitionTypeOptionContent: React.FC<TuitionTypeOptionContentProps> = ({
  type,
  label,
  showSelectedIndicator = false,
  selectedLabel = 'Selected',
}) => (
  <>
    <div className="flex h-10 items-center justify-center">
      {type === 'both' ? (
        <div className="grid w-[4.5rem] grid-cols-2 place-items-center">
          <Home className={iconClassName} />
          <Monitor className={iconClassName} />
        </div>
      ) : (
        <div className="flex w-[4.5rem] items-center justify-center">
          {type === 'physical' ? (
            <Home className={iconClassName} />
          ) : (
            <Monitor className={iconClassName} />
          )}
        </div>
      )}
    </div>
    <span className="flex min-h-[2.5rem] items-center justify-center text-center text-sm leading-5">
      {label}
    </span>
    {showSelectedIndicator ? (
      <span className="text-xs font-semibold">✓ {selectedLabel}</span>
    ) : null}
  </>
);

export default TuitionTypeOptionContent;
